import * as React from 'react';
import { SVGProps } from 'react';

const IconFileImageSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3h20v18H2V3Zm1 1v10.793l2.11-2.111a5.5 5.5 0 0 1 7.78 0l2.077 2.078a3.933 3.933 0 0 1 5.764.123l.269.302V4H3Zm18 12.69-1.016-1.143a2.933 2.933 0 0 0-4.31-.08L20.207 20H21v-3.31ZM18.793 20l-6.611-6.61a4.5 4.5 0 0 0-6.364 0L3 16.206V20h15.793ZM14.5 8.25a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM16.75 7a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
    />
  </svg>
);
export default IconFileImageSizeM;
